import React from 'react';
import { IconButton, Box, Tooltip } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

interface StudentActionsProps {
  id: string;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export const StudentActions: React.FC<StudentActionsProps> = ({ 
  id, 
  onEdit, 
  onDelete 
}) => {
  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEdit(id);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(id);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
      <Tooltip title="Edit student">
        <IconButton 
          size="small" 
          onClick={handleEdit}
          aria-label="Edit student"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete student">
        <IconButton 
          size="small" 
          onClick={handleDelete}
          color="error"
          aria-label="Delete student"
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};